<template>
  <v-textarea
    v-model="textValue"
    v-bind="$attrs"
    :outlined="outlined"
    :solo="solo"
    :dense="dense"
    :readonly="readonly"
    :rows="rows"
    :maxLength="maxLength"
    :label="labelValue"
    :rules="rules"
    required
    @keydown="keydown"
    @keypress="keypress"
    @change="change"
    @click:append="append"
  >
    <template v-if="!!tooltipText" #prepend-inner>
      <v-sheet width="30" color="transparent">
        <TooltipWithIcon top size="22" text="none" :message="tooltipText" />
      </v-sheet>
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />

    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-textarea>
</template>

<script>
export default {
  name: 'CustomTextarea',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 3,
    },
    maxLength: {
      type: Number,
      default: null,
    },
    label: {
      type: [String, Number],
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    tooltipText: {
      type: String,
      default: '',
    },
  },
  computed: {
    textValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    labelValue() {
      return this.rules.length ? this.label + ' *' : this.label
    },
  },
  methods: {
    keydown(value) {
      this.$emit('keydown', value)
    },
    keypress(value) {
      this.$emit('keypress', value)
    },
    change(value) {
      this.$emit('change', value)
    },
    append(value) {
      this.$emit('click:append', value)
    },
  },
}
</script>
